import { __extends } from "tslib";
import * as PropTypes from 'prop-types';
import * as React from 'react';
var isDescendant = function (el, target) {
    if (target !== null) {
        return el === target || isDescendant(el, target.parentNode);
    }
    return false;
};
var outsideClickEvents = ['mouseup', 'touchend'];
var bind = function (callback) {
    return outsideClickEvents.forEach(function (event) {
        return document.addEventListener(event, callback);
    });
};
var unbind = function (callback) {
    return outsideClickEvents.forEach(function (event) {
        return document.addEventListener(event, callback);
    });
};
var OutsideClick = /** @class */ (function (_super) {
    __extends(OutsideClick, _super);
    function OutsideClick() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.outsideClickRef = React.createRef();
        _this.isCurrentlyMounted = false;
        _this.handleClickAway = function (evt) {
            if (_this.isCurrentlyMounted && _this.outsideClickRef.current) {
                var onOutsideClick = _this.props.onOutsideClick;
                var el = _this.outsideClickRef.current;
                if (document.documentElement &&
                    document.documentElement.contains(evt.target) &&
                    !isDescendant(el, evt.target)) {
                    if (onOutsideClick)
                        onOutsideClick(evt);
                }
            }
        };
        return _this;
    }
    OutsideClick.prototype.componentDidMount = function () {
        var onOutsideClick = this.props.onOutsideClick;
        this.isCurrentlyMounted = true;
        if (onOutsideClick) {
            bind(this.handleClickAway);
        }
    };
    OutsideClick.prototype.componentDidUpdate = function (prevProps) {
        var onOutsideClick = this.props.onOutsideClick;
        if (prevProps.onOutsideClick !== onOutsideClick) {
            unbind(this.handleClickAway);
            if (onOutsideClick) {
                bind(this.handleClickAway);
            }
        }
    };
    OutsideClick.prototype.componentWillUnmount = function () {
        this.isCurrentlyMounted = false;
        unbind(this.handleClickAway);
    };
    OutsideClick.prototype.render = function () {
        var children = this.props.children;
        return children({ outsideClickRef: this.outsideClickRef });
    };
    OutsideClick.propTypes = {
        children: PropTypes.func,
        onOutsideClick: PropTypes.func,
    };
    return OutsideClick;
}(React.Component));
export { OutsideClick };
//# sourceMappingURL=OutsideClick.js.map